import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ActionLink from "../../../../controls/ActionLink";
import CompanyContactRow from "./CompanyContactRow";

class CompanyContactTable extends Component {
    static propTypes = {
        contacts: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        contacts: this.props.contacts
    };

    componentWillReceiveProps({contacts}) {
        if (contacts.length != this.props.contacts.length)
            this.setState({contacts});
    }

    render() {
        return (
            <div>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>Контактное лицо*</th>
                        <th>Телефон*</th>
                        <th>Email*</th>
                        <th/>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.contacts.length
                            ? this.state.contacts.map((contact, i) =>
                                <CompanyContactRow key={i} data={contact}
                                                   onUpdate={contact => this.updateContact(i, contact)}
                                                   onRemove={() => this.removeContact(i)}/>
                            )
                            : <tr>
                                <td className="text-center" colSpan="5">
                                    Контакты отсутствуют. Нажмите кнопку
                                    {' '}
                                    <ActionLink onClick={() => this.createContact()}>
                                        Добавить контакт
                                    </ActionLink>
                                    {' '}
                                    для создания.
                                </td>
                            </tr>
                    }
                    </tbody>
                </table>
                <button type="button" className="btn btn-default btn-outline"
                        onClick={() => this.createContact()}>
                    <i className="fa fa-plus"/> Добавить контакт
                </button>
            </div>
        );
    }

    createContact() {
        const {contacts} = this.state;

        contacts.push({
            name: '',
            phoneNumber: '',
            email: '',
            isUser: false,
            isOtherCompanyUser: false,
            isReceiveEmailNotification: false
        });

        this.setState({contacts});
    }

    updateContact(index, contact) {
        const {onChange} = this.props;
        const {contacts} = this.state;

        contacts[index] = contact;

        this.setState({contacts}, () => onChange(this.state.contacts));
    }

    removeContact(index) {
        let contacts = this.state.contacts;

        contacts.splice(index, 1);
        this.setState({contacts});
    }
}

export default CompanyContactTable;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Companies/components/CompanyContactTable.js